const translations = [
  { "en-US": "Clone" },
  { "en-US": "Phone Numbers" },
  { "en-US": "Charting" },
  { "en-US": "Consent Forms" },
];

export default translations;
